import styled from 'styled-components';

export const MenuList = styled.ul`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	padding: 0;
`;

export const MenuListWrapper = styled.div`
	border: 2px solid #dddddd;
	border-left: none;
	width: 43px;
	padding: 7px;
	height: 851px;
`;

export const CircleButtonContainer = styled.div`
	position: absolute;
	right: -6px;
	bottom: -12px;
`;

export const Counter = styled.div`
	position: relative;
`;
